import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api, formatApiError, setToken } from "@/lib/api";
import Logo from "@/components/Logo";

export default function RegisterPage() {
    const { user } = useAuth();
    const nav = useNavigate();
    const [params] = useSearchParams();
    const ref = params.get("ref") || "";

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => { if (user && user !== false) nav("/"); }, [user, nav]);

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setBusy(true);
        try {
            const { data } = await api.post("/auth/register", { email, password, name, ref: ref || null });
            setToken(data.token);
            // Go straight to growth page so users see their referral link immediately
            window.location.assign("/growth");
        } catch (e) {
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg)]" data-testid="register-page">
            <div className="w-full max-w-md">
                <Logo size="sm" />
                {ref && (
                    <div className="mt-8 border border-[var(--gold-deep)] bg-[var(--surface)] p-4 flex items-center justify-between gap-4" data-testid="ref-banner">
                        <div>
                            <p className="label-tiny mb-1 text-[var(--gold-bright)]">Invited by</p>
                            <p className="font-mono text-sm">{ref}</p>
                        </div>
                        <span className="tag-pill border-[var(--gold)] text-[var(--gold-bright)] whitespace-nowrap">FOUNDER INVITE</span>
                    </div>
                )}
                <p className="label-tiny mt-10 mb-3">/ Create account</p>
                <h2 className="font-serif text-5xl mb-10">Join NDE Fitness.</h2>

                <form onSubmit={submit} className="space-y-5" data-testid="register-form">
                    <div>
                        <label className="label-tiny block mb-2">Full name</label>
                        <input data-testid="register-name" className="input-dark" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div>
                        <label className="label-tiny block mb-2">Email</label>
                        <input data-testid="register-email" type="email" className="input-dark" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div>
                        <label className="label-tiny block mb-2">Password</label>
                        <input data-testid="register-password" type="password" minLength={6} className="input-dark" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    {err && <div className="border border-[var(--danger)] bg-[var(--danger)]/10 text-[var(--danger)] px-3 py-2 text-sm" data-testid="register-error">{err}</div>}
                    <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="register-submit">
                        {busy ? "Creating…" : "Create account →"}
                    </button>
                </form>

                <div className="gold-rule my-10" />
                <p className="text-sm text-[var(--text-muted)]">
                    Already have an account?{" "}
                    <Link to="/login" className="text-[var(--gold)]" data-testid="goto-login">Sign in</Link>
                </p>
            </div>
        </div>
    );
}
